import type { Filter, Input } from "@/workflow_api/types/core";
import type { Variable } from "./types";
import {
  CONTEXT_GLOBAL_TYPES,
  getNodeIdForContextVariable,
  isHolderLegalGlobalType,
  mapBackendTypeToVariableType,
} from "./useVariableResolver.helpers";

export const resolveGlobalVariable = (
  input: Input[number],
): Variable | null => {
  if (!input.global_type) return null;
  if (input.global_type === "PERSON_TYPE") {
    return {
      id: "PERSON_TYPE",
      global_type: "PERSON_TYPE",
      type: "string",
      ref_name: "",
      name: "",
      node_id: "holder-base-variables",
    };
  }
  if (input.global_type === "COMPANY_FIELD") {
    return {
      id: input.value as string,
      global_type: "COMPANY_FIELD",
      type: mapBackendTypeToVariableType(input.type || ""),
      ref_name: "",
      name: "",
      node_id: "expedient-variables",
    };
  }
  if (isHolderLegalGlobalType(input.global_type)) {
    return {
      id: input.value as string,
      global_type: input.global_type,
      type: mapBackendTypeToVariableType(input.type || ""),
      ref_name: "",
      name: "",
      node_id: "holder-legal-variables",
    };
  }
  if (input.global_type?.includes("NODE_EXECUTION")) {
    const subfix = input.global_type?.includes("START")
      ? "execution_start"
      : "execution_finish";
    const name = input.global_type?.includes("START")
      ? "inicio-nodo"
      : "fin-nodo";
    const nodeId = input.value as string;
    return {
      id: `${nodeId}_${subfix}`,
      name,
      node_id: nodeId,
      ref_name: "",
      type: "date",
      global_type: input.global_type,
    };
  }

  // For legacy global_type, map to new ones
  if (input.global_type === "APPLICANT") {
    if (input.value === "name") {
      return {
        id: "name",
        global_type: "HOLDER",
        type: mapBackendTypeToVariableType(input.type || ""),
        ref_name: "",
        name: "",
        node_id: "holder-personal-variables",
      };
    }

    return {
      id: input.value as string,
      global_type: "HOLDER",
      type: mapBackendTypeToVariableType(input.type || ""),
      ref_name: "",
      name: "",
      node_id: "holder-personal-variables",
    };
  }

  if (
    input.global_type === "CURRENT_TIME" ||
    input.global_type === "LAST_OBSERVATION_DATE"
  ) {
    return {
      id: input.value as string,
      global_type: input.global_type,
      type: mapBackendTypeToVariableType(input.type || ""),
      ref_name: "",
      name: "",
      node_id: "global-variables",
    };
  }
  if (CONTEXT_GLOBAL_TYPES.has(input.global_type)) {
    return {
      id: input.value as string,
      global_type: input.global_type,
      type: mapBackendTypeToVariableType(input.type || ""),
      ref_name: "",
      name: "",
      node_id: getNodeIdForContextVariable(
        input.global_type,
        input.value as string,
      ),
    };
  }
  if (input.global_type === "FORMALITY_REQUEST") {
    return {
      id: input.value as string,
      global_type: input.global_type,
      type: mapBackendTypeToVariableType(input.type || ""),
      ref_name: "",
      name: "",
      node_id: "global-variables",
    };
  }
  return null;
};

export const resolveGlobalFilterToVariable = (
  input: Filter,
): Variable | null => {
  if (!input.global_type) return null;

  if (input.global_type === "PERSON_TYPE") {
    return {
      id: "PERSON_TYPE",
      global_type: "PERSON_TYPE",
      type: "string",
      ref_name: "",
      name: "",
      node_id: "holder-base-variables",
    };
  }

  if (input.global_type === "COMPANY_FIELD") {
    return {
      id: input.value as string,
      global_type: "COMPANY_FIELD",
      type: mapBackendTypeToVariableType(input.type || ""),
      ref_name: "",
      name: "",
      node_id: "expedient-variables",
    };
  }

  if (isHolderLegalGlobalType(input.global_type)) {
    return {
      id: input.value as string,
      global_type: input.global_type,
      type: mapBackendTypeToVariableType(input.type || ""),
      ref_name: "",
      name: "",
      node_id: "holder-legal-variables",
    };
  }
  if (input.global_type?.includes("NODE_EXECUTION")) {
    const subfix = input.global_type?.includes("START")
      ? "execution_start"
      : "execution_finish";
    const name = input.global_type?.includes("START")
      ? "inicio-nodo"
      : "fin-nodo";
    const nodeId = input.value as string;
    return {
      id: `${input.global_type}_${subfix}`,
      name,
      node_id: nodeId,
      ref_name: "",
      type: "date",
      global_type: input.global_type,
    };
  }
  if (
    input.global_type === "APPLICANT" ||
    input.global_type === "CURRENT_TIME" ||
    input.global_type === "LAST_OBSERVATION_DATE"
  ) {
    return {
      id: input.value as string,
      global_type: input.global_type,
      type: mapBackendTypeToVariableType(input.type || ""),
      ref_name: "",
      name: "",
      node_id: "global-variables",
    };
  }
  if (CONTEXT_GLOBAL_TYPES.has(input.global_type)) {
    return {
      id: input.value as string,
      global_type: input.global_type,
      type: mapBackendTypeToVariableType(input.type || ""),
      ref_name: "",
      name: "",
      node_id: getNodeIdForContextVariable(
        input.global_type,
        input.value as string,
      ),
    };
  }
  return null;
};
